import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {CitizensServicesProvisionMeans, filteringInputCitiProvicion} from './citizens-services-provision-means.model';

export const loadCitizensServicesProvisionMeanss = createAction(
  '[CitizensServicesProvisionMeans/API] Load CitizensServicesProvisionMeanss',
  props<{ citizensServicesProvisionMeanss: CitizensServicesProvisionMeans[] }>()
);

export const addCitizensServicesProvisionMeans = createAction(
  '[CitizensServicesProvisionMeans/API] Add CitizensServicesProvisionMeans',
  props<{ citizensServicesProvisionMeans: CitizensServicesProvisionMeans }>()
);

export const upsertCitizensServicesProvisionMeans = createAction(
  '[CitizensServicesProvisionMeans/API] Upsert CitizensServicesProvisionMeans',
  props<{ citizensServicesProvisionMeans: CitizensServicesProvisionMeans }>()
);

export const addCitizensServicesProvisionMeanss = createAction(
  '[CitizensServicesProvisionMeans/API] Add CitizensServicesProvisionMeanss',
  props<{ citizensServicesProvisionMeanss: CitizensServicesProvisionMeans[] }>()
);

export const upsertCitizensServicesProvisionMeanss = createAction(
  '[CitizensServicesProvisionMeans/API] Upsert CitizensServicesProvisionMeanss',
  props<{ citizensServicesProvisionMeanss: CitizensServicesProvisionMeans[] }>()
);

export const updateCitizensServicesProvisionMeans = createAction(
  '[CitizensServicesProvisionMeans/API] Update CitizensServicesProvisionMeans',
  props<{ citizensServicesProvisionMeans: Update<CitizensServicesProvisionMeans> }>()
);

export const updateCitizensServicesProvisionMeanss = createAction(
  '[CitizensServicesProvisionMeans/API] Update CitizensServicesProvisionMeanss',
  props<{ citizensServicesProvisionMeanss: Update<CitizensServicesProvisionMeans>[] }>()
);

export const deleteCitizensServicesProvisionMeans = createAction(
  '[CitizensServicesProvisionMeans/API] Delete CitizensServicesProvisionMeans',
  props<{ id: string }>()
);

export const deleteCitizensServicesProvisionMeanss = createAction(
  '[CitizensServicesProvisionMeans/API] Delete CitizensServicesProvisionMeanss',
  props<{ ids: string[] }>()
);

export const clearCitizensServicesProvisionMeanss = createAction(
  '[CitizensServicesProvisionMeans/API] Clear CitizensServicesProvisionMeanss'
);

//CUSTOM
export const citizenGetServicesProvisionMeans = createAction(
  '[CitizensServicesProvisionMeans/API] citizen Get Services Provision Means',
  props<{ filtering:filteringInputCitiProvicion }>()
);
